import React from "react";
import "./heroSection.css";
import "../../index.css";
import Button from "../button/button";
import { useState } from "react";
import PopUpModal from "../../popUpForms/formModals/popUpFormModal";
import PopUpFormDownloadScorecard from "../../popUpForms/popUpFormDownloadScorecard";
const HeroSection = (s) => {
  const [popUpFormVisible, setPopUpFormVisible] = useState(false);
  const [activeForm, setActiveForm] = useState("");

  const handleShowPopUpForm = () => {
    setActiveForm("download");
    setPopUpFormVisible(true);
  };

  return (
    <>
      <div className="banner-container">
        <div className="bg-image">
          <img
            src="/images/home/CanadaWildfireBannerGradient.png"
            alt="CWPC Home"
          />
        </div>
        <div className="large-screen-limit">
          <div className="hero-content-wrapper">
            <div className="banner-text-right ">
              <sup>1 </sup>Canada wildfires burn record 45.7 million acres in
              2023
            </div>
            <div className="banner-text-left">
              <h2 className="banner-top hero-text">
                Catastrophic Fires Destroy
              </h2>
              <h1 className="hero-text banner-mid">
                Community Preparation Saves{" "}
              </h1>
              <h4 className="banner-bottom hero-text">
                Everyone's contribution counts. Together we overcome
                catastrophe.
              </h4>
              <Button
                text="Download Scorecard"
                color="var(--dark-blue)"
                onClick={handleShowPopUpForm}
              />
            </div>
            <div className="banner-photo-credit-container">
              <p className="banner-credit">
                Photo credit: BC Wildfire Service
                <br />
                <sup>1 </sup>Source Credit:{" "}
                <a
                  href="https://www.theguardian.com/world/2023/nov/09/canada-wildfire-record-climate-crisis#img-1"
                  aria-label="link to the canada wildfire article in the Guardian"
                  target="_blank"
                  rel="nonreferer noreferrer"
                >
                  The Guardian{" "}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <PopUpModal
        activeForm={"download"}
        formActiveState={popUpFormVisible}
        setFormActiveState={setPopUpFormVisible}
      >
        <PopUpFormDownloadScorecard />
      </PopUpModal>
    </>
  );
};

export default HeroSection;
